module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('extra-filter'), _vm._v(" "), _c('div', {
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.extras), function(extra, index) {
    return (_vm.extras && _vm.extras.length) ? _c('extra', {
      key: extra.slug,
      attrs: {
        "index": index,
        "extra": extra
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.extras || !_vm.extras.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try again")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-waypoint', {
    on: {
      "waypoint-in": _vm.nextPage
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.scrolled) ? _c('button', {
    staticClass: "sttButton button is-primary",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._v("Top")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-553ce8fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Extras.vue
// module id = 781
// module chunks = 1